// Renders ContentSection[] from police-content.ts as long-form body.
import type { ContentSection } from "@/data/police-content";

export function PoliceSections({ sections }: { sections: ContentSection[] }) {
  return (
    <div className="mx-auto max-w-4xl space-y-10">
      {sections.map((s, i) => (
        <section key={i} className="space-y-4">
          <h2 className="font-display text-2xl font-extrabold text-navy-deep sm:text-3xl">
            {s.heading}
          </h2>
          {s.paragraphs.map((p, j) => (
            <p key={j} className="text-[15px] leading-relaxed text-slate-700 sm:text-base">
              {p}
            </p>
          ))}
        </section>
      ))}
    </div>
  );
}
